<template>
  <div class="login-contaniner h-100 d-flex align-items-center">
    <div class="login-left">
      <img :src="leftBgUrl" alt="" />
    </div>
    <div class="login-right">
      <div class="logo-login cursor-pointer" @click="() => $router.push('/')">
        <img :src="loginLogoUrl" alt="" />
      </div>

      <!-- 登录 -->
      <template v-if="loginType === 1">
        <h3 class="mb-0">{{ $t("message.login.loginWelcome") }}</h3>
        <p class="desc" v-html="$t('message.index.banner.content2')"></p>
        <!-- <p class="desc" v-html="$t('message.login.loginTitle')"></p> -->
        <div class="login-tabs">
          <el-form ref="accountForm" :model="accountForm" label-width="0" class="login-box" :rules="accountRules"
            @submit.native.prevent>
            <el-form-item label="">
              <el-input :placeholder="$t('message.login.loginUsername')" prefix-icon="el-icon-s-custom"
                v-model="accountForm.username"></el-input>
            </el-form-item>

            <el-form-item label="">
              <el-input :type="pwdType1" :placeholder="$t('message.login.loginPassword')" prefix-icon="el-icon-lock"
                v-model="accountForm.password">
                <i slot="suffix" :class="['el-input__icon icon-eye', suffixIcon1]" @click="showPwd(1)"></i>
              </el-input>
            </el-form-item>
            <!-- 记住账号密码 -->
            <el-checkbox v-model="isKeepAccount" class="ml-2 mt-4">{{
              $t("message.login.rememberAccount")
            }}</el-checkbox>
            <el-form-item>
              <el-button type="primary" class="loginBtn" native-type="submit" v-on:click="onSubmit('accountForm')"
                :disabled="!accountForm.username || !accountForm.password">
                {{ $t("message.login.loginButton") }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="register-tips" @click="goRegister">
          {{ $t("message.login.loginTips") }}
          <i class="el-icon-right"></i>
        </div>
      </template>
      <!-- 注册 -->
      <template v-if="loginType === 2">
        <h3 class="mb-0">{{ $t("message.login.registerWelcome") }}</h3>
        <p class="desc" v-html="$t('message.login.loginTitle')"></p>
        <div class="login-tabs">
          <el-form ref="registerForm" :model="registerForm" label-width="0" class="login-box" :rules="registerRules"
            @submit.native.prevent>
            <el-form-item label="" prop="username">
              <el-input :placeholder="$t('message.login.registerUsername')" prefix-icon="el-icon-s-custom"
                v-model="registerForm.username"></el-input>
            </el-form-item>

            <el-form-item label="" v-if="false"></el-form-item>

            <el-form-item label="" prop="password">
              <el-input :type="pwdType2" :placeholder="$t('message.login.registerPassword')" prefix-icon="el-icon-lock"
                v-model="registerForm.password">
                <i slot="suffix" :class="['el-input__icon icon-eye', suffixIcon2]" @click="showPwd(2)"></i>
              </el-input>
            </el-form-item>

            <el-form-item label="" prop="confirmPassword">
              <el-input :type="pwdType3" :placeholder="$t('message.login.registerConfirmPassword')"
                prefix-icon="el-icon-lock" v-model="registerForm.confirmPassword">
                <i slot="suffix" :class="['el-input__icon icon-eye', suffixIcon3]" @click="showPwd(3)"></i>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" class="loginBtn" native-type="submit" v-on:click="onRegister('registerForm')"
                :disabled="!registerForm.username ||
                  !registerForm.password ||
                  !registerForm.confirmPassword
                  ">
                <!-- 注册 -->
                {{ $t("message.login.registerButton") }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="register-tips" @click="goLogin">
          <!-- 已有账户？立即登录 -->
          {{ $t("message.login.registerTips") }}
          <i class="el-icon-right"></i>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["currentLang"],
  data() {
    return {
      loginType: 1, // 1 登录 2 注册
      leftBgUrl: require("@/assets/images/login/login-bg.jpg"),
      loginLogoUrl: require("@/assets/images/login/login-logo.png"),
      accountForm: {
        username: "",
        password: "",
      },
      registerForm: {
        username: "",
        password: "",
        confirmPassword: "",
      },
      isKeepAccount: true, // 是否记住账号
      pwdType1: "password",
      suffixIcon1: "icon-eye-close",
      pwdType2: "password",
      suffixIcon2: "icon-eye-close",
      pwdType3: "password",
      suffixIcon3: "icon-eye-close",
    };
  },
  computed: {
    accountRules() {
      const validatLoginPass1 = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t("message.userEdit.msg1")));
        } else if (
          value.toString().length < 8 ||
          value.toString().length > 18
        ) {
          callback(new Error(this.$t("message.userEdit.msg2")));
        } else {
          let hasLetter = false;
          let hasNumber = false;
          let hasSymbol = false;
          for (let char of value) {
            if (/[a-zA-Z]/.test(char)) {
              hasLetter = true;
            } else if (/\d/.test(char)) {
              hasNumber = true;
            } else {
              hasSymbol = true;
            }
          }
          var arr = [hasLetter, hasNumber, hasSymbol];
          if (arr.filter((item) => item).length < 2) {
            callback(new Error(this.$t("message.userEdit.msg2")));
          }
          callback();
        }
      };
      return {
        // username: [{ required: true, message: this.$t('message.login.validatorMsg.validatePhone'), trigger: 'blur' }],
        // password: [{ required: true, validator: validatLoginPass1, trigger: 'blur' }],
        username: [
          {
            required: true,
            message:
              this.$t("message.userEdit.pleaseEnter") +
              this.$t("message.userEdit.userName"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("message.userEdit.msg1"),
            trigger: "blur",
          },
        ],
      };
    },
    registerRules() {
      const validateRegisterPass1 = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t("message.userEdit.msg1")));
        } else if (
          value.toString().length < 8 ||
          value.toString().length > 18
        ) {
          callback(new Error(this.$t("message.userEdit.msg2")));
        } else {
          let hasLetter = false;
          let hasNumber = false;
          let hasSymbol = false;
          for (let char of value) {
            if (/[a-zA-Z]/.test(char)) {
              hasLetter = true;
            } else if (/\d/.test(char)) {
              hasNumber = true;
            } else {
              hasSymbol = true;
            }
          }
          var arr = [hasLetter, hasNumber, hasSymbol];
          if (arr.filter((item) => item).length < 2) {
            callback(new Error(this.$t("message.userEdit.msg2")));
          }
          callback();
        }
      };
      const validateRegisterPass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("message.userEdit.msg3")));
        } else if (value !== this.registerForm.password) {
          callback(new Error(this.$t("message.userEdit.msg4")));
        } else {
          callback();
        }
      };
      return {
        username: [
          {
            required: true,
            message:
              this.$t("message.userEdit.pleaseEnter") +
              this.$t("message.userEdit.userName"),
            trigger: "blur",
          },
        ],
        password: [
          { required: true, validator: validateRegisterPass1, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, validator: validateRegisterPass2, trigger: "blur" },
        ],
      };
    },
  },
  created() {
    // 检查是否有账号密码的cookies，有就回填
    var isUsernameCookies = this.$vueCookies.isKey("keep_username");
    var isUserpsdCookies = this.$vueCookies.isKey("keep_userpsd");
    if (isUserpsdCookies && isUsernameCookies) {
      this.accountForm.username = this.$vueCookies.get("keep_username");
      this.accountForm.password = this.$vueCookies.get("keep_userpsd");
    }
  },
  methods: {
    // 记住账号密码
    keepPsdChange(val) {
      if (val && !this.$utils.isEmpty(this.accountForm.password)) {
        this.$vueCookies.set(
          "keep_username",
          this.accountForm.username,
          30 * 60 * 60 * 24
        ); // 30天过期
        this.$vueCookies.set(
          "keep_userpsd",
          this.accountForm.password,
          30 * 60 * 60 * 24
        ); // 30天过期
      } else {
        this.$vueCookies.remove("keep_username");
        this.$vueCookies.remove("keep_userpsd");
      }
    },
    // 密码显示隐藏
    showPwd(flag) {
      if (this["pwdType" + flag] === "password") {
        this["suffixIcon" + flag] = "icon-eye-open";
        this["pwdType" + flag] = "";
      } else {
        this["suffixIcon" + flag] = "icon-eye-close";
        this["pwdType" + flag] = "password";
      }
    },

    // 登录
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api
            .login({
              username: this.accountForm.username,
              password: this.accountForm.password,
            })
            .then((data) => {
              if (data.code == 200) {
                this.$vueCookies.set("token", data.token); // 浏览器会话结束时过期
                // 记住密码
                this.keepPsdChange(this.isKeepAccount);

                // dxx：判断，如果初次进入，直接跳转home页面；如果在别的页面停留过久，token失效，则登录以后直接跳转到当前页面
                var redirect = this.$route.query.redirect;
                if (redirect != "" && redirect != undefined) {
                  // 避免多次跳转&转义URL符号
                  if (redirect.split("redirect").length > 1) {
                    this.$router.push("/index");
                  } else {
                    this.$router.push(redirect);
                  }
                } else {
                  this.$router.push("/index");
                }
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },

    // 去注册
    goRegister() {
      this.loginType = 2;
      this.$refs.accountForm.resetFields();
    },

    // 去登录
    goLogin() {
      this.loginType = 1;
      this.$refs.registerForm.resetFields();
    },

    // 注册
    onRegister(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api
            .login({
              username: this.registerForm.username,
              password: this.registerForm.password,
            })
            .then((data) => {
              if (data.result.code == 0) {
                this.$message.success(this.$t("message.registerSuccess"));
                this.loginType = 1;
                this.$refs.registerForm.resetFields();
              } else {
                this.$message.error(data.result.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-contaniner {
  width: 100%;
  height: 100%;
  color: var(--text-color);
  background-color: var(--background-color);

  .login-left {
    width: 60%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .login-right {
    width: 40%;
    height: 100%;
    padding: 0 100px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;

    .logo-login {
      position: absolute;
      right: 100px;
      top: 50px;

      img {
        height: 35px;
      }
    }

    h3 {
      font-size: 56px;
      font-family: "Alibaba-PuHuiTi-Medium";
      font-weight: 500;
    }

    p.desc {
      font-size: 24px;
      margin-top: 10px;
      margin-bottom: 20px;
    }

    .login-tabs {
      .login-box {
        ::v-deep() {
          .el-form-item--small.el-form-item {
            margin-bottom: 0;
            margin-top: 26px;
          }

          .el-input--small .el-input__inner {
            background-color: var(--inner-background-color) !important;
            height: 70px;
            line-height: 70px;
            border-radius: 50px;
            font-size: 18px;
            padding: 0 50px;
            color: var(--text-color);
            border: none;
          }

          .el-input--small .el-input__icon {
            font-size: 20px;
          }

          .el-input__prefix {
            left: 20px;
          }

          .el-input__suffix {
            right: 20px;
          }

          .el-checkbox__label {
            color: var(--text-color);
            font-size: 16px;
          }

          .el-checkbox__input.is-checked+.el-checkbox__label {
            color: var(--primary-color);
          }

          .el-checkbox__inner {
            background-color: transparent;
          }

          .el-checkbox__input.is-checked .el-checkbox__inner,
          .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: var(--primary-color);
            border-color: var(--primary-color);
          }

          .icon-eye {
            display: block;
            cursor: pointer;
          }

          .icon-eye::before {
            content: "";
            display: block;
            width: 24px;
            height: 24px;
            position: absolute;
            top: 50%;
            transform: translate(0%, -50%);
          }

          .icon-eye-close::before {
            background: url("@/assets/images/login/icon-eye-close.png") no-repeat center center;
            object-fit: cover;
            background-size: 100%;
          }

          .icon-eye-open::before {
            background: url("@/assets/images/login/icon-eye-open.png") no-repeat center center;
            object-fit: cover;
            background-size: 100%;
          }

          .loginBtn {
            width: 100%;
            height: 70px;
            line-height: 70px;
            border-radius: 50px;
            font-size: 18px;
            margin-top: 30px;
            padding: 0;
            background-color: var(--primary-color);
            border-color: var(--primary-color);
          }
        }
      }
    }

    .register-tips {
      width: 100%;
      text-align: center;
      margin-top: 30px;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>
